import { Check, Warning } from "@mui/icons-material";

export default function StatusIcon({ status }) {
  if (status === "alert")
    return (
      <Warning
        sx={{
          fontSize: "1em",
          color: "red",
        }}
      />
    );
  else
    return (
      <Check
        sx={{
          fontSize: "1em",
          color: "green",
        }}
      />
    );
}
